import { render, staticRenderFns } from "./TipGolStats.vue?vue&type=template&id=044167d8&scoped=true&"
import script from "./TipGolStats.vue?vue&type=script&lang=js&"
export * from "./TipGolStats.vue?vue&type=script&lang=js&"
import style0 from "./TipGolStats.vue?vue&type=style&index=0&id=044167d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044167d8",
  null
  
)

export default component.exports